import { observer } from 'mobx-react-lite'
import { type AddCouponDialogViewModel } from './AddCouponDialogViewModel'
import { AddCouponDialog } from '@/features/call-center/AddCouponDialog'

export interface AddCouponDialogContainerProps {
  vm: AddCouponDialogViewModel
}

export const AddCouponDialogContainer = observer(
  function AddCouponDialogContainer({ vm }: AddCouponDialogContainerProps) {
    return (
      <AddCouponDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        isPending={vm.applyCouponAsAdmin.pending}
        onApply={vm.applyCouponAsAdmin}
        couponCode={vm.couponCode}
        onCouponCodeChange={vm.setCouponCode}
      />
    )
  },
)
